const IN_WPS_HOST = window.location.host.includes('wps.cn')
const BASE_URL_WPS = 'https://vas2t-api.wps.cn/open-partner/v1'
const BASE_URL_KDOCS = 'https://vas2t-api.kdocs.cn/open-partner/v1'
const ACCOUNT_WPS = 'https://account.wps.cn'
const ACCOUNT_KDOCS = 'https://account.kdocs.cn'
const DRIVE_WPS = 'https://drive.wps.cn'
const DRIVE_KDOCS = 'https://drive.kdocs.cn'

// 2T相关服务
export const BASE_URL = IN_WPS_HOST ? BASE_URL_WPS : BASE_URL_KDOCS;

// 账户相关服务
export const ACCOUNT_URL = IN_WPS_HOST ? ACCOUNT_WPS : ACCOUNT_KDOCS;

// 用户信息相关服务
export const DIRIVE_URL = IN_WPS_HOST ? DRIVE_WPS : DRIVE_KDOCS;

// 最大分组数量
export const MAX_GROUP_NUM = 100;

// 应用方主题配置
export const APP_THEME_KEYS = { normal: '--theme-common-01', hover: '--theme-common-02', active: '--theme-common-03' };

// commonjs cdn
export const COMMON_JS_CDN = '//vas2t.wpscdn.cn/vas2t-prod/sdk/libs/js/common2t/20240403/common2t.pc.js'

// 邀请链接分割标识符
export const LINKCODE_SPLIT = '  '

// iframe 通知事件名称
export const INVITE_CONFIRM_SEARCH = 'invite-confirm-search'
export const INVITE_CONFIRM_SELECT = 'invite-confirm-select'
export const INVITE_CONFIRM_SUCCESS = 'invite-confirm-success'